import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { costsService } from '@/services/costsService';
import type { CostSimulation, SimulationResult } from '@/types/admin.types';

export function useCostConfigs() {
  return useQuery({
    queryKey: ['admin', 'costs', 'config'],
    queryFn: costsService.getConfigs,
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export function useUpdateCostConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ type, costPerUnit }: { type: string; costPerUnit: number }) =>
      costsService.updateConfig(type, costPerUnit),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'costs', 'config'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'costs', 'margin'] });
    },
  });
}

export function useMarginAnalysis(period?: string) {
  return useQuery({
    queryKey: ['admin', 'costs', 'margin', period],
    queryFn: () => costsService.getMarginAnalysis(period),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export function useCostSimulation() {
  return useMutation<SimulationResult, Error, CostSimulation>({
    mutationFn: (simulation: CostSimulation) => costsService.simulate(simulation),
  });
}
